export const LOT_STATUS = {
  pending: 'Processing', // FE displays Processing
  awaiting_approval: 'Awaiting Approval', // FE displays Confirm button
  completed: 'Confirmed', // after confirming the lot, FE displays Confirmed
  failed: 'Needs Review', // if there is a validation error, or just a timeout failure, it requires attention
  processing: 'Processing' // not a used status yet
};
